import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';
import { UserBadge } from '@bizzabo/collaboration-common';
import { GetStreamUser } from '@bizzabo/chat-core';
import UnbanUserActions from './UnbanUserActions';
import { UserRole } from '../../types/UserRole';

export interface BanUserItemProps {
    user: GetStreamUser;
    unBanUserTriggered: (userId: string) => void;
    chatUserRole: UserRole;
}

const BanUserItem: React.FC<BanUserItemProps> = ({ unBanUserTriggered, user, chatUserRole }) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.userContainer}>
                <UserBadge user={user} />
                {chatUserRole === UserRole.Moderator && (
                    <UnbanUserActions
                        unBanUserTriggered={unBanUserTriggered}
                        userId={user.providerId}
                    />
                )}
            </div>
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            height: 70,
            margin: 20,
            borderBottom: `1px solid ${theme.palette.greys['300']}`,
        },
        userContainer: { display: 'flex' },
    }),
    {
        classNamePrefix: 'BanUserItem',
    }
);

export default BanUserItem;
